import buildClientAPI from 'views/providers/clientAPI'
import { IState } from 'types/redux'
import { RedpointsInfo, RedPointStatus } from 'types/redux/checkout/redpoints'
import { NewCustomerStatus } from 'types/redux/checkout'
import { getCustomerId, addCheckoutErrorAction } from './common'
import { REDPOINTS_SUBSCRIPTION_STATUS_NO_MEMBER } from 'shared/consts/redpointsSubscription'

// ---------------------------- ACTION TYPES -------------------------

export const FETCH_REDPOINTS_STATUS_REQUEST = 'FETCH_REDPOINTS_STATUS_REQUEST'
export const FETCH_REDPOINTS_STATUS_SUCCESS = 'FETCH_REDPOINTS_STATUS_SUCCESS'
export const FETCH_NEW_CUSTOMER_REQUEST = 'FETCH_NEW_CUSTOMER_REQUEST'
export const FETCH_NEW_CUSTOMER_SUCCESS = 'FETCH_NEW_CUSTOMER_SUCCESS'
export const SUBMIT_OPT_IN_CODE_REQUEST = 'SUBMIT_OPT_IN_CODE_REQUEST'
export const SUBMIT_OPT_IN_CODE_SUCCESS = 'SUBMIT_OPT_IN_CODE_SUCCESS'
export const SET_REDPOINTS_REGISTRATION = 'SET_REDPOINTS_REGISTRATION'

// ---------------------------- SELECTORS -------------------------

export const getRedpointsInfo = (state: IState): RedpointsInfo => {
  return {
    redPointsStatus: state?.checkout?.redPointsStatus,
    redPointsValue:
      state?.checkout?.orderDraft?.orderMasterData?.totalAmountRedpoints,
    orderCount: state?.checkout?.newCustomerStatus,
    registerForRedPoints: state?.checkout?.verification?.registerForRedPoints
  }
}

export const getRegisterForRedPoints = (state: IState): boolean => {
  return state?.checkout?.verification?.registerForRedPoints
}

export const getRedPointsStatus = (state: IState): string => {
  return (
    state?.checkout?.redPointsStatus || REDPOINTS_SUBSCRIPTION_STATUS_NO_MEMBER
  )
}

export const getTotalRedeemedRedpointsAmount = (state: IState): number =>
  state?.checkout?.orderDraft?.orderMasterData?.totalAmountDiscountRedpoints ||
  0

// ---------------------------- ACTIONS -------------------------

export const fetchRedPointsStatusSuccessAction = (
  redPointsStatus: RedPointStatus
) => {
  return {
    type: FETCH_REDPOINTS_STATUS_SUCCESS,
    redPointsStatus
  }
}

export const fetchRedPointsStatusRequest = () => {
  return {
    type: FETCH_REDPOINTS_STATUS_REQUEST
  }
}

export const fetchNewCustomerSuccessAction = (
  newCustomerStatus: NewCustomerStatus
) => {
  return {
    type: FETCH_NEW_CUSTOMER_SUCCESS,
    newCustomerStatus
  }
}

export const fetchNewCustomerRequest = () => {
  return {
    type: FETCH_NEW_CUSTOMER_REQUEST
  }
}

export const setRedPointsRegistrationAction = (
  registerForRedPoints: boolean
) => {
  return {
    type: SET_REDPOINTS_REGISTRATION,
    registerForRedPoints
  }
}

export const submitOptInCodeSuccessAction = () => {
  return {
    type: SUBMIT_OPT_IN_CODE_SUCCESS
  }
}

export const submitOptInCodeRequest = () => {
  return {
    type: SUBMIT_OPT_IN_CODE_REQUEST
  }
}

// ---------------------------- THUNK -------------------------

export const fetchRedPointsStatusAction = (): ((
  dispatch: Function,
  getState: () => IState
) => Promise<void>) => {
  return async (dispatch: Function, getState: () => IState): Promise<void> => {
    dispatch(fetchRedPointsStatusRequest())
    try {
      const { redPointsService } = buildClientAPI()
      const response = await redPointsService.getRegistrationStatus(
        getCustomerId(getState())
      )
      const { status } = response.data
      dispatch(fetchRedPointsStatusSuccessAction(status))
    } catch (e) {
      dispatch(
        addCheckoutErrorAction(`fetchRedPointsStatusAction: ${e.message}`)
      )
    }
  }
}

export const fetchNewCustomerAction = (): ((
  dispatch: Function
) => Promise<void>) => {
  return async (dispatch: Function): Promise<void> => {
    dispatch(fetchNewCustomerRequest())
    try {
      const { ordersService } = buildClientAPI()
      const response = await ordersService.fetchAllCustomerOrders()
      const { totalItems } = response.data

      dispatch(fetchNewCustomerSuccessAction(totalItems))
    } catch (e) {
      dispatch(addCheckoutErrorAction(`fetchNewCustomerAction: ${e.message}`))
    }
  }
}

// used in CheckoutConnectedCartSumBox
export const submitOptInCodeAction = (): ((
  dispatch: Function,
  getState: () => IState
) => Promise<void>) => {
  return async (dispatch: Function, getState: () => IState): Promise<void> => {
    dispatch(submitOptInCodeRequest())
    try {
      const { redPointsService } = buildClientAPI()
      const req = {
        shopCustomerID: getCustomerId(getState())
      }
      await redPointsService.createOptInCode(req, {})
      dispatch(submitOptInCodeSuccessAction())
    } catch (e) {
      dispatch(addCheckoutErrorAction(`submitOptInCodeAction: ${e.message}`))
    }
  }
}
